import { render, staticRenderFns } from "./RankingView.vue?vue&type=template&id=4a35268e&"
import script from "./RankingView.vue?vue&type=script&lang=js&"
export * from "./RankingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports